import { Modal, Typography } from 'antd';
import { Product, useProducts } from '@hooks';

const { Paragraph } = Typography;

interface DeleteProductModalProps {
  open: boolean;
  onCancel: () => void;
  product: Product | null;
  onSuccess: () => void;
}

export const DeleteProductModal = ({ open, onCancel, product, onSuccess }: DeleteProductModalProps) => {
  const { deleteProduct } = useProducts();

  const handleDelete = async () => {
    if (product) {
      try {
        await deleteProduct.mutateAsync(product.id);
        onSuccess();
      } catch (error) {
        console.error('Error deleting product:', error);
      }
    }
  };

  return (
    <Modal
      title={
        <span className="font-android text-yellow-principal text-xl uppercase tracking-wider">
          Confirm Delete
        </span>
      }
      open={open}
      onCancel={onCancel}
      onOk={handleDelete}
      okText="DELETE"
      cancelText="CANCEL"
      okButtonProps={{
        danger: true,
        loading: deleteProduct.isPending,
        className: 'font-android uppercase tracking-wider',
      }}
      cancelButtonProps={{
        className: 'font-android uppercase tracking-wider',
      }}
      styles={{
        mask: { backdropFilter: 'blur(10px)', backgroundColor: 'rgba(0,0,0,0.7)' },
        content: { backgroundColor: '#181717', border: '1px solid #3f3f46', borderRadius: '0px' },
        header: { backgroundColor: '#181717', borderBottom: '1px solid #3f3f46' },
      }}
    >
      <div className="py-4">
        <Paragraph className="font-['Barlow'] text-white text-lg">
          Are you sure you want to delete the product "{product?.name}"?
        </Paragraph>
        <Paragraph className="font-['Barlow'] text-gray-400">
          This action cannot be undone. The product will be permanently removed from your catalog.
        </Paragraph>
      </div>
    </Modal>
  );
};

